module.exports = __webpack_public_path__ + "static/media/7h_website_logo_Gold_delta.8b13c10b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/7h_website_logo_Gold_delta.jpg
// module id = 116
// module chunks = 0